import React from "react";
import { Shield, Leaf, Thermometer, Droplets } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const advantagesData = [{
  title: "Qualifications & Experience",
  description: "A Bachelor's degree in Finance or Accounting is required, alongside 5+ years of experience in financial administration within the professional services or consulting sector.",
  iconName: "shield"
}, {
  title: "Strong Strategic Assets",
  description: "Proficiency in advanced ERP systems and financial modeling is essential. Candidates with a CPA designation and experience in multi-entity reporting will be highly prioritized.",
  iconName: "leaf"
}, {
  title: "Success Profile & Impact",
  description: "The ideal lead demonstrates exceptional attention to detail and the ability to translate complex financial data into actionable insights for executive-level decision making.",
  iconName: "thermometer"
}, {
  title: "Collaborative Leadership",
  description: "Proven ability to mentor junior staff and foster a culture of continuous improvement within the financial operations team at RiverBend.",
  iconName: "droplets"
}];
const renderIcon = (name: string) => {
  switch (name) {
    case "shield":
      return <Shield className="w-6 h-6" />;
    case "leaf":
      return <Leaf className="w-6 h-6" />;
    case "thermometer":
      return <Thermometer className="w-6 h-6" />;
    case "droplets":
      return <Droplets className="w-6 h-6" />;
    default:
      return <Shield className="w-6 h-6" />;
  }
};
export default function Advantages() {
  return;
}